<script module>
  export { default as layout } from '@layouts/authentication-layout.svelte'
</script>

<svelte:head>
  <title>Create Account</title>
</svelte:head>

<script>
  import { onMount } from 'svelte'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import { Link, useForm, router } from '@inertiajs/svelte'
  import Logo from '@assets/images/altruist-vertical-logo.svg'
  import { User } from 'lucide-svelte'

  onMount(() => {
    const storedValues = sessionStorage.getItem('altruist-signup-form-values')
    if (storedValues) {
      $form.user = { ...JSON.parse(storedValues), password: '' }
      sessionStorage.removeItem('altruist-signup-form-values')
    }
  })

  const form = useForm({
    user: {
      name: '',
      email_address: '',
      password: '',
      accept_terms: false,
    }
  })

  function viewTerms() {
    const { password, ...safeValues } = $form.user
    sessionStorage.setItem('altruist-signup-form-values', JSON.stringify(safeValues))
    router.visit('/terms-and-conditions')
  }

  function handleSubmit(e) {
    e.preventDefault()
    sessionStorage.removeItem('altruist-signup-form-values')
    $form.post('/users')
  }

</script>

<div class="flex min-h-0 flex-1 flex-col">
  <div class="flex flex-1 flex-col justify-center">
    
    <!-- Logo -->
    <div class="flex justify-center mb-10">
      <img src={Logo} alt="Altruist" class="w-28" />
    </div>

    <!-- Heading -->
    <h1 class="text-[34px] text-gray-700 font-serif text-center mb-6">Welcome, create your account</h1>

    <Form.Element {form} id="signup-form" class="auth-form" onsubmit={handleSubmit} allowEnterSubmit>

      <Form.Items class="gap-6">

        <!-- Name -->
        <Form.Item name="name" label="Your name" type="text" placeholder="Forename Surname" bind:value={$form.user.name} validate={false} required autofocus>
          {#snippet prefix()}
            <User size={16} class="text-gray-400" />
          {/snippet}
        </Form.Item>

        <!-- Email address -->
        <Form.Item name="email_address" label="Email address" type="email" placeholder="your-email@company.com" bind:value={$form.user.email_address} validate={false} required />

        <!-- Password -->
        <Form.Item name="password" label="Password" type="password" placeholder="Enter a password" autocomplete="new-password" minLength={6} bind:value={$form.user.password} validate={false} required />

        <!-- Accept terms -->
        <label class="checkbox-label col-span-12 flex items-center gap-3">
          <input type="checkbox" name="accept_terms" bind:checked={$form.user.accept_terms} required />
          <span class="text-sm text-gray-700 font-normal">
            I agree to the Altruist Wellbeing
            <Button variant="naked" onclick={viewTerms} text="Terms & Conditions. *" class="text-gray-800 underline underline-offset-3 hover:underline hover:text-primary-700 text-sm" />
          </span>
        </label>

      </Form.Items>

      <Form.Submit variant="bold" size="lg" class="mt-6 flex-1 w-full h-12 border-none hover:border-none justify-center" text="Create account" loading={$form.processing} />

    </Form.Element>
  </div>

  <div class="pt-4 text-center text-sm text-gray-700">
    Already a member?
    <Link href="/session/new" class="text-gray-700 hover:text-primary-700 no-underline border-b-2 border-primary-500">Sign in here</Link>.
  </div>
</div>
